import { createSelector } from 'reselect';
import MixedTrayUsageColumns from '../../containers/MixedTrayUsageColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.MIXED_TRAY_USAGE_942.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.MIXED_TRAY_USAGE_942.isLoading;

export const getData =
  ReportDefinitions.MIXED_TRAY_USAGE_942.getDataFunction();

export const getColumns =
  createSelector(getData, MixedTrayUsageColumns);
